module.exports = __webpack_public_path__ + "static/world-9eed9e0ceeb1fcd501c0cf347b4d7375.png";